<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                <van-col span="12">
                    <div class="banner-title">输入手机号</div>
                </van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="apply-box">
            <div class="apply-value">
<!--                <input class="a-input" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11" v-model="phone"-->
<!--                       placeholder="请输入对方手机号">-->
                <van-field oninput="value=value.replace(/[^\d]/g,'')" maxlength="11" v-model="phone" placeholder="请输入对方手机号" />
            </div>
        </div>
        <div class="send-btn" @click="findMembers"><span class="btn-text">确认</span></div>
    </div>
</template>

<script>
    import {Notify} from 'vant';

    export default {
        name: 'phone',
        data() {
            return {
                theme: 'light',
                phone: '',
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
        },
        methods: {
            back() {
                this.$router.back();
            },
            findMembers() {
                if (this.phone.length < 11) return;
                this.$api.share.findMembers({
                    phone: this.phone
                }).then(res => {
                    let user = res.info;
                    localStorage.setItem("addUser", JSON.stringify(user));
                    this.$router.push({
                        name: 'confirmLight',
                        params: {
                            type: 'phone'
                        },
                        query: {
                            theme: this.theme
                        }
                    })
                }).catch(e => {
                    console.log(e);
                    Notify({type: 'danger', message: e.remark});
                })
            }
        }
    }
</script>

<style scoped>
    .apply-box {
        margin-top: 15px;
    }

    .apply-value {
        width: 345px;
        height: 56px;
        margin: 0 auto;
        background: var(--bg-color-2);
        opacity: 1;
        border-radius: 10px;
        position: relative;
    }

    /deep/ input {
        background-color: transparent;
        color: var(--text-color-1);
        font-size: 15px;
        caret-color: #00BD9B;
        line-height: 36px;
    }

    /deep/ input::-webkit-input-placeholder{
        color: var(--text-color-3);
    }

    /deep/ input::-moz-placeholder{
        color: rgba(0,0,0,0.2);
    }

    /deep/ input:-moz-placeholder{
        color: rgba(0,0,0,0.2);
    }

    /deep/ input::-ms-input-placeholder{
        color: rgba(0,0,0,0.2);
    }

    .send-btn {
        width: 345px;
        height: 52px;
        border-radius: 13px 13px 13px 13px;
        border: 2px solid #404040;
        font-size: 15px;
        line-height: 52px;
        text-align: center;
        position: absolute;
        bottom: 34px;
        left: 15px;
    }

    .btn-text {
        color: var(--text-color-1);
        font-size: 17px;
    }

    /deep/ .van-cell {
        background-color: var(--bg-color-2) !important;
        border-radius: 10px;
        height: 56px;
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/11phone.vue